import actions from './../vuex/alerts/action_types.js'

export default {
    methods: {
        $_updatePaymentAndUnallocatedDocumentAlert: function() {
            this.$store.dispatch(actions.FETCH_PAYMENTS_AND_UNALLOCATED_DOCUMENTS_COUNT)
                .then(response => {
                        const alert_total = document.getElementById('summaries-alters-count');
                        const alert = document.getElementById('alert-payments-and-unallocated-documents');
                        alert_total.innerHTML = response.data.count;
                        alert.innerHTML = response.data.count;
                    })
        }
    }
}